import React, { useState, useEffect } from 'react';
import { getGenders } from '../../services/api';

export default function GenderEntry({ onGenderChange }) {
  const [selectedGenero, setSelectedGenero] = useState('');
  const [genders, setGenders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGenders = async () => {
      try {
        const response = await getGenders();
        // Filtrar cualquier opción que contenga "Persona Moral" o "Moral"
        const filteredGenders = response.filter(
          gender =>
            !gender.gender_name.toLowerCase().includes('moral') &&
            !gender.gender_name.toLowerCase().includes('persona moral')
        );
        setGenders(filteredGenders);
      } catch (error) {
        console.error('Error fetching genders:', error);
        // Fallback a opciones hardcodeadas sin persona moral
        setGenders([
          { id_gender: '1', gender_name: 'Masculino' },
          { id_gender: '2', gender_name: 'Femenino' },
          { id_gender: '3', gender_name: 'Otro' },
          { id_gender: '4', gender_name: 'Prefiero no contestar' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchGenders();
  }, []);

  const handleChange = e => {
    const value = e.target.value;
    setSelectedGenero(value);
    if (onGenderChange) {
      onGenderChange(value);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando opciones...
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={selectedGenero}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none bg-white"
      >
        <option value="" disabled>
          Seleccione Género
        </option>
        {genders.map(gender => (
          <option key={gender.id_gender} value={gender.id_gender}>
            {gender.gender_name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
}
